// src/components/home/HomeServices.jsx

import React from "react";
import { Link } from "react-router-dom";

import { homeServices } from "../../data/homeData";

import "./css/HomeServices.css";

const HomeServices = () => {
  return (
    <section className="home-services">

      <div className="home-container">

        <div className="home-section-heading services-heading">

          <div>

            <span className="home-section-eyebrow">
              OUR SERVICES
            </span>

            <h2>
              Ayurvedic care
              <br />
              <em>designed around you.</em>
            </h2>

          </div>

          <p>
            Explore our range of Ayurvedic consultations,
            therapies and wellness services.
          </p>

        </div>


        <div className="services-editorial-grid">

          {homeServices.map((service, index) => (
            <Link
              to="/services"
              className={`service-editorial-card service-card-${index + 1}`}
              key={service.title}
            >

              <div className="service-image">

                <img
                  src={service.image}
                  alt={service.title}
                />

              </div>

              <div className="service-overlay"></div>

              <span className="service-number">
                0{index + 1}
              </span>

              <div className="service-content">

                <h3>
                  {service.title}
                </h3>

                <p>
                  {service.description}
                </p>

                <span className="service-explore">
                  Explore service →
                </span>

              </div>

            </Link>
          ))}

        </div>


        <div className="services-bottom-link">

          <Link
            to="/services"
            className="home-button home-button-dark"
          >
            View All Services
          </Link>

        </div>

      </div>

    </section>
  );
};

export default HomeServices;